<template>
  <p class="field">
    <app-checkbox :title="title" :name="name" :checked="checked" @change="$emit('change', $event)" />
    <app-input :name="name" :value="value" disabled v-if="!textarea" />
    <textarea :name="name" rows="6" cols="50" disabled="" v-if="textarea" v-model="value"></textarea>
  </p>
</template>

<script>
export default {
  name: 'item-checkbox-input',
  props: {
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    textarea: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  }
}
</script>
